import { Props } from './Layout'

export const useProps = (): Props => {
  return {}
}
